import chroma from "chroma-js";
const colorLevel = (textDefault, textAlt) => (colorHex, level = 0) => {
  const colorBase = level > 0 ? textDefault : textAlt;
  const absLevel = Math.abs(level) * 0.08;
  const upperLevel = absLevel > 1 ? 1 : absLevel;
  const mixLevel = absLevel < 0 ? 0 : upperLevel;
  return chroma.mix(colorBase, colorHex, mixLevel).hex();
};
export default colorLevel;
